var $ = require('jquery');
require('bootstrap');
require('jquery-countto');
require('./utilities/class_enlarge.js');
require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');


jQuery("img").on("contextmenu",false).on("dragstart",false);

